import { render } from "./DetailBerita.vue?vue&type=template&id=c892e804"
import script from "./DetailBerita.vue?vue&type=script&lang=js"
export * from "./DetailBerita.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__